const files = require.context('.', true, /\.vue$/)
const modules = {}

files.keys().forEach((key) => {
  if (key === './index.js') return
  
  var module = key.replace(/(\.\/|\.vue)/g, '')
  module = module.replace(/\//g, '_')
  modules[module] = files(key).default
})

export default modules